<script setup lang="ts">
import { ChevronRight, Loader, Play, VideoOff } from 'lucide-vue-next'
import { useI18n } from 'vue-i18n'
import { Icon } from '@iconify/vue'
import { showToast } from 'vant'
import { useRouter } from 'vue-router'
import IconVip from '@/assets/imgs/vip.svg'

defineProps<{
  requiresLogin: boolean
  isPremium: boolean
  isError: boolean
  isBuffering: boolean
  isPaused: boolean
  isLogin: boolean
}>()

const router = useRouter()
const { t } = useI18n()
</script>

<template>
  <!-- 需要登录 -->
  <div v-if="requiresLogin" class="absolute inset-0 flex items-center justify-center">
    <div class="flex flex-col gap-4 items-center opacity-90 text-white/80">
      <Icon class="text-9xl text-purple-600/60" icon="solar:user-bold-duotone" />
      <p class="text-center text-sm">{{ t('component.videoFeedback.loginPrompt') }}</p>
      <button
        class="bg-purple-600 text-white px-4 py-2 mt-10 rounded-full cursor-pointer text-sm hover:bg-purple-700 transition-colors"
        @click="router.push('/login')"
      >
        {{ t('component.videoFeedback.goLogin') }}
      </button>
    </div>
  </div>

  <!-- 付费视频 -->
  <div v-else-if="isPremium" class="absolute inset-0 flex items-center justify-center">
    <div class="flex flex-col gap-4 items-center opacity-90">
      <img :src="IconVip" alt="VIP" />
      <p class="text-center text-sm text-yellow-400">{{ t('component.videoFeedback.vipRequired') }}</p>
      <span
        v-if="isLogin"
        @click="showToast(t('component.videoFeedback.uploadPrompt'))"
        class="text-yellow-400 underline cursor-pointer"
        >立即开通</span
      >
      <span v-else @click="router.push('/login')" class="flex items-center gap-2 text-yellow-400 cursor-pointer">
        {{ t('component.videoFeedback.goLogin') }}
        <ChevronRight :size="20" />
      </span>
    </div>
  </div>

  <!-- 视频错误 -->
  <div v-else-if="isError" class="absolute inset-0 flex items-center justify-center">
    <div class="flex flex-col gap-4 items-center opacity-60">
      <VideoOff :size="86" :stroke-width="1" />
      <p class="text-white text-center text-sm">{{ t('component.videoFeedback.error') }}</p>
    </div>
  </div>

  <!-- 缓冲指示器 -->
  <Loader
    v-else-if="isBuffering"
    :size="56"
    class="opacity-60 animate-spin pointer-events-none absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
  />

  <!-- 暂停指示器 -->
  <Play
    v-else-if="isPaused"
    :size="56"
    class="fill-white pointer-events-none stroke-white opacity-60 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 scale-125 transition-all duration-200"
  />
</template>
